import type { FaireProductEntity } from "../../entity_types/product";

export const p_xz2fzy3cqc: FaireProductEntity = {
  token: "p_xz2fzy3cqc",
  type: "product",
  name: "Beef Tallow Potato Chips - Sea Salt",
  brandToken: "b_d6aqh4qdhb",
  brandName: "Beefy's Own",
  imageUrl: "https://cdn.faire.com/fastly/fa6c3ce0dd4d0af456d2791c5d46d719cfbc8965623654abf21517dcde95acb0.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/395ec18f247aaba10ce74d4bafbd4c49c6664a253f959c967524d15c44617e07.png",
    "https://cdn.faire.com/fastly/ed6e0bd42d878b1eb816b81fb98a467ae6bf4aa4317329bc07ea15f7a67f06a5.png",
    "https://cdn.faire.com/fastly/c891511fedce69a9daf41acf91dff7d7a4ffc94ba626e4d8c9da5c7b569ffd2d.png",
    "https://cdn.faire.com/fastly/cd6399735a7b74102b02e67c3fce7ac10991586b7227ffec17c8951d65eb1acb.png",
    "https://cdn.faire.com/fastly/2ed7c019a921bdfa8606cd8f764bdb723b5b332dc655a696cd5178566fdbbf05.png",
    "https://cdn.faire.com/fastly/d5e33cdefa78448fa870e48f32d9dd29161bf1de941da4d8d48617b2137a4f2f.png",
    "https://cdn.faire.com/fastly/7f48e09f0b6f6f2e7ab56cd9c5097c642105e53929eb94d65628d941b31d7b32.png",
    "https://cdn.faire.com/fastly/f29a9e3814838d42222b4cba00d5cdb72a4fae181c88a68f8cc7bdd705d14fbd.png",
    "https://cdn.faire.com/fastly/8d8ec8b49976e9847561473f2ef24c0596583c51a454c9b5070901075de593ce.png",
    "https://cdn.faire.com/fastly/b11cf5d04806ce43670eb365fd4e5a67aedf85f612c59ea8d0046adfc9b8e0d3.png"
  ],
  priceDollars: 6.5,
  description: "Crafted with care in Derry, NH, our kettle-cooked potato chips are everything a chip should be: crispy, golden, and full of flavor. Our dedicated team of chip artisans takes pride in ensuring every chip meets the highest standards of taste and texture. From the satisfying crunch to the perfectly seasoned finish, these small-batch chips deliver a snack experience like no other. Each batch is made by hand using just three simple, high-quality ingredients:\n\nNon-GMO Potatoes, Beef Tallow, Sea Salt\n\n-5oz bags-\n",
  tags: [],
  msrpDollars: 9.99,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-15T21:11:38.112Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
